module.exports = __webpack_public_path__ + "img/icon_dianpu_PDD.573d9882.png";